const ArrayFormatters = {
  toWords: (array) => {
    if (array.length > 2) {
      return array.slice(0, -1).join(', ') + ', and ' + array.slice(-1)
    } else if (array.length === 2) {
      return array.join(" and ")
    } else {
      return array.join(', ')
    }
  }
};

export default ArrayFormatters;



// WEBPACK FOOTER //
// ./src/utils/arrayFormatters.js